import { http } from '@/http'

// Plantillas de contrato (DOCX con placeholders) por empresa, multi-tag por tipo de contrato.
export default {
  listByCompany(companyId, onlyActive = false) {
    return http.get(`/companies/${companyId}/contract-templates`, { params: { onlyActive } })
  },
  get(id) {
    return http.get(`/contract-templates/${id}`)
  },
  duplicates(companyId, types, excludeId) {
    const params = { types: (types || []).join(',') }
    if (excludeId) params.excludeId = excludeId
    return http.get(`/companies/${companyId}/contract-templates/duplicates`, { params })
  },
  create(companyId, formData) {
    return http.post(`/companies/${companyId}/contract-templates`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  updateMetadata(id, data) {
    return http.put(`/contract-templates/${id}`, data)
  },
  replaceFile(id, formData) {
    return http.put(`/contract-templates/${id}/file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  remove(id) {
    return http.delete(`/contract-templates/${id}`)
  },
  variantsCount(id) {
    return http.get(`/contract-templates/${id}/variants-count`)
  },
  downloadFile(id) {
    return http.get(`/contract-templates/${id}/file`, { responseType: 'blob' })
  },
  placeholders() {
    return http.get('/contract-templates/placeholders')
  },
}
